import css from "./FriendListItem.module.css";

export default function FriendListItem({ avatar, name, isOnline }) {
  return (
    <div className={css.friendsListItem}>
      <img className={css.avatar} src={avatar} alt='Avatar' width='48' />
      <p className={css.friendName}>{name}</p>
      <p
        className={`${css.networkStatus} ${
          isOnline ? css.online : css.offline
        }`}>
        {isOnline ? "Online" : "Offline"}
      </p>
    </div>
  );
}
